import api from '@/api/api';
import { BOXES_API } from '@/variables';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    create({ rootGetters }, payload) {
      const section = rootGetters.get_app_section;

      return api().post(`${section}${BOXES_API}`, payload)
        .then((resp) => resp.data);
    },
    ship({ rootGetters }, payload) {
      const { id } = payload;
      const section = rootGetters.get_app_section;

      return api().put(`${section}${BOXES_API}/${id}/ship`)
        .then((resp) => {
          if (resp.status !== 200) throw new Error();
          return resp.data;
        });
    },
    delete({ rootGetters }, payload) {
      const { id } = payload;
      const section = rootGetters.get_app_section;

      return api().delete(`${section}${BOXES_API}/${id}`)
        .then((resp) => resp.data);
    },
  },
};
